import React, { useState, useEffect } from "react";
import { updateStudent, createStateStudent, getStudent } from "../../../services/StudentRecordService.js";
import { getAllCourses } from "../../../services/CourseService.js";
import { getAllAgents } from "../../../services/AgentService.js";
import { getAllStudents } from "../../../services/StudentRecordService.js";
import { v4 as uuidv4 } from "uuid";

const initialCourse = {
  id: "",
  courseName: "",
  coeNumber: "",
  courseStartDate: "",
  courseEndDate: "",
  coeStatus: "",
  coeIssuedDate: "",
  courseDuration: "",
  courseHolidayWeeks: "",
  courseTuitionWeeks: "",
  classPerWeek: "3 days",
  decision: "",
  prismsDueDate: "",
  prismStatus: "",
  remarks: "",
  revisedCOE: "",
};

const options = {
  gender: ["Male", "Female", "Other"],
  campusName: ["Canberra", "Melbourne"],
  classPerWeek: ["3 days", "5 days"],
  coeType: ["Primary", "Package", "Extension"],
  feePlanType: ["Independent", "Package"],
  visaApplicationType: ["Onshore", "Offshore"],
  enrolmentType: ["COE", "VOE"],
  coeStatus: ["Ongiong (Issued)", "Pending", "Withdrawn", "Cancelled"],
  decision: ["Granted", "Refused", "Pending"],
  prismStatus: ["Activated", "Reported", "Pending", "Not Required"],
};

function StudentRecordForm({ onCancel, initialData, onSaveSuccess  }) {
  const [formData, setFormData] = useState({
    studentId: "",
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    email: "",
    phone: "",
    createdBy: "",
    onshoreAddress: "",
    offshoreAddress: "",
    campusName: "",
    coeType: "",
    feePlanType: "",
    visaApplicationType: "",
    enrolmentType: "",
    agentName: "",
    usiNumber: "",
    offerLetterDetails: "",
    studentStatus: "",
    leadingTo: "",
    contactID: "",

    // offer letter details
    address: "",
    citizenship: "",
    suburb: "",
    state: "",
    postcode: "",
    passportNumber: "",
    passportExpiry: "",
    visaType: "",
    visaExpiryDate: "",

    // Emergency Details
    emergencyContactName: "",
    emergencyContactRelation: "",
    emergencyContactNumber: "",
  });
  
  const [courses, setCourses] = useState([initialCourse]);
  const [availableCourses, setAvailableCourses] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEditingContactID, setIsEditingContactID] = useState(false);

  useEffect(() => {
    if (initialData?.formState) {
      setFormData({
        studentId: initialData.formState.studentId || "",
        firstName: initialData.formState.firstName || "",
        lastName: initialData.formState.lastName || "",
        gender: initialData.formState.gender || "",
        dateOfBirth: initialData.formState.dateOfBirth || "",
        email: initialData.formState.email || "",
        phone: initialData.formState.phone || "",
        createdBy: initialData.formState.createdBy || "",
        onshoreAddress: initialData.formState.onshoreAddress || "",
        offshoreAddress: initialData.formState.offshoreAddress || "",
        campusName: initialData.formState.campusName || "",
        coeType: initialData.formState.coeType || "",
        feePlanType: initialData.formState.feePlanType || "",
        visaApplicationType: initialData.formState.visaApplicationType || "",
        enrolmentType: initialData.formState.enrolmentType || "",
        offerLetterDetails: initialData.formState.offerLetterDetails || "",
        agentName: initialData.formState.agentName || "",
        usiNumber: initialData.formState.usiNumber || "",
        studentStatus: initialData.formState.studentStatus || "",
        leadingTo: initialData.formState.leadingTo || "",
        packages: initialData.formState.packages || [],
        contactID: initialData.formState.contactID || "",

        // Preserve the additional fields for existing/new student records.
        address: initialData.formState.address || "",
        citizenship: initialData.formState.citizenship || "",
        suburb: initialData.formState.suburb || "",
        state: initialData.formState.state || "",
        postcode: initialData.formState.postcode || "",
        passportNumber: initialData.formState.passportNumber || "",
        passportExpiry: initialData.formState.passportExpiry || "",
        visaType: initialData.formState.visaType || "",
        visaExpiryDate: initialData.formState.visaExpiryDate || "",

        emergencyContactName: initialData.formState.emergencyContactName || "",
        emergencyContactRelation: initialData.formState.emergencyContactRelation || "",
        emergencyContactNumber: initialData.formState.emergencyContactNumber || "",
      });

      setCourses(
        initialData.formState.courses?.length > 0
          ? initialData.formState.courses
          : [initialCourse]
      );
    } else {
      setFormData({
        studentId: "",
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirth: "",
        email: "",
        phone: "",
        createdBy: "",
        onshoreAddress: "",
        offshoreAddress: "",
        campusName: "",
        coeType: "",
        feePlanType: "",
        visaApplicationType: "",
        enrolmentType: "",
        offerLetterDetails: "",
        agentName: "",
        usiNumber: "",
        studentStatus: "",
        leadingTo: "",
        packages: [],
        contactID: "",

        address: "",
        citizenship: "",
        suburb: "",
        state: "",
        postcode: "",
        passportNumber: "",
        passportExpiry: "",
        visaType: "",
        visaExpiryDate: "",

        emergencyContactName: "",
        emergencyContactRelation: "",
        emergencyContactNumber: "",
      });
      setCourses([initialCourse]);
    }
  }, [initialData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleEditContactID = (e) => {
    setIsEditingContactID((prev) => !prev);
  }

  const handleCourseChange = (index, e) => {
    const { name, value } = e.target;
    const updatedCourses = [...courses];
    updatedCourses[index][name] = value;

    // Auto-calculate prismsDueDate = courseStartDate + 5 days
    if (name === "courseStartDate" && value) {
      const startDate = new Date(value);
      startDate.setDate(startDate.getDate() + 5);
      const formattedDate = startDate.toISOString().split("T")[0];
      updatedCourses[index].prismsDueDate = formattedDate;
    }
     // --- Auto-calculate course duration and holidays (exact match only) ---
    const startDate = updatedCourses[index].courseStartDate
      ? new Date(updatedCourses[index].courseStartDate)
      : null;
    const endDate = updatedCourses[index].courseEndDate
      ? new Date(updatedCourses[index].courseEndDate)
      : null;

    if (startDate && endDate && endDate > startDate) {
      const diffMs = endDate - startDate;
      const totalWeeks = Math.round(diffMs / (1000 * 60 * 60 * 24 * 7)); // difference in weeks
      updatedCourses[index].courseDuration = totalWeeks;

      // Exact match logic for holidays
      if (totalWeeks === 52) {
        updatedCourses[index].courseHolidayWeeks = 12;
        updatedCourses[index].courseTuitionWeeks = 40;
      } else if (totalWeeks === 104) {
        updatedCourses[index].courseHolidayWeeks = 24;
        updatedCourses[index].courseTuitionWeeks = 80;
      }
    } else if (updatedCourses[index].courseDuration === 52) {
        updatedCourses[index].courseHolidayWeeks = 12;
        updatedCourses[index].courseTuitionWeeks = 40;
      } else if (updatedCourses[index].courseDuration === 104) {
        updatedCourses[index].courseHolidayWeeks = 24;
        updatedCourses[index].courseTuitionWeeks = 80;
      }

    setCourses(updatedCourses);
  };


  const addCourse = () => {
    const newCourse = { 
      courseName: "",
      coeNumber: "",
      courseStartDate: "",
      courseEndDate: "",
      coeStatus: "",
      coeIssuedDate: "",
      courseDuration: "",
      courseHolidayWeeks: "",
      courseTuitionWeeks: "",
      classPerWeek: "3 day",
      decision: "",
      prismsDueDate: "",
      prismStatus: "",
      remarks: "",
      revisedCOE: "",
      id: uuidv4() };
    setCourses([...courses, newCourse]);
  };
  const onRequestDelete = () => {
    alert("Share this Id for deletion request: " + (initialData?.id || "N/A"));
  }

  const removeCourse = (index) => {
    const updated = [...courses];
    updated.splice(index, 1);
    setCourses(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (errorMessage) {
      alert(errorMessage);
      return;
    }

    // Preserve all existing Student Record formState values.
    const savedData = {
      ...(initialData?.formState || {}),
      ...formData,
      courses
    };

    try {
      // Double-check with backend before saving
      if(formData.studentId.trim() !== "") {
        const allStudents = await getAllStudents(formData.studentId);
        const students = Array.isArray(allStudents)
          ? allStudents
          : allStudents?.data || [];
        // Inside handleSubmit before saving
        if (students && students.length > 0) {
          // Check if any course has a duplicate id (excluding the current student/course being edited)
          const duplicateStudent = students.find(
            (student) =>
              student.formState?.studentId?.trim() === formData.studentId.trim() &&
              student.id !== initialData?.id // exclude the record currently being edited
          );

          if (duplicateStudent) {
            alert(`Student ID "${duplicateStudent.formState.studentId}" already exists.`);
            return; // stop submission
          }
        }
      }
      
      let savedRecord = null;

      if (initialData?.id) {
        // EXISTING STUDENT
        // Keep the exact same existing ID and update flow.
        await updateStudent(
          initialData.id,
          initialData.enrolmentReferenceId,
          savedData
        );

        savedRecord = {
          ...initialData,
          formState: {
            ...savedData
          }
        };
        alert("Student record saved successfully!");

      } else {
        // NEW STUDENT
        // Keep your existing creation flow exactly the same.
        const createdResponse = await createStateStudent(
          savedData,
          "",
          ""
        );

        // Use the ID created by your EXISTING Firebase flow.
        const createdId =
          createdResponse?.id ||
          createdResponse;

        if (createdId) {
          const createdStudent = await getStudent(createdId);

          savedRecord = {
            id: createdId,
            ...createdStudent
          };
        }
        alert("Student record saved successfully!");

      if (savedRecord && typeof onSaveSuccess === "function") {
        onSaveSuccess(savedRecord);
      } else if (typeof onCancel === "function") {
        onCancel();
      }
      }
    } catch (error) {
      alert("Failed to save student record. Please try again." + error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchCourses = async () => {
        try {
          const data = await getAllCourses();
          const filteredCourses = data.filter(
            (c) => c.status.toLowerCase() === "active" && !c.courseName.toLowerCase().includes("test")
          );
          setAvailableCourses(filteredCourses);
        } catch (error) {
          alert("Failed to load courses");
        }
    };

    fetchCourses();
  }, []);
  // Fetch agents
  useEffect(() => {
    const fetchAgents = async () => {
        try {
          const data = await getAllAgents();
          const filteredAgents = data.filter(agent =>
            (agent.status.toLowerCase() === "active" || agent.status.toLowerCase() === "suspended") &&  !agent.agentName.toLowerCase().includes("test")
          );
          setAgentList(filteredAgents || []);
        } catch (error) {
          alert("Failed to load agents");
        }
    };
    fetchAgents();
  }, []);

  return (
    <div className="form-container">
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            borderRadius: "12px"
          }}
        >
          <div className="spinner" style={{ textAlign: "center" }}>
            <div className="loader" style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 12px",
              
            }} />
            
          </div>
          <p style={ {
            padding: "0.5rem",
          }
          }>Saving, please wait!</p>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div
          className="actions"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <div>
            <h1 className="page-title">Student Record</h1>
            <p className="page-subtitle">Create and manage Students</p>
          </div>

          <div style={{ display: "flex", gap: "1rem" }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onRequestDelete}
            >
              Request Delete
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </div>

        {/* Student Info */}
        <div className="form-section">
          <h2>Student Information</h2>
          <br />
          <div className="form-grid">
            
            {[
              { label: "Student ID", name: "studentId" },
              { label: "First Name", name: "firstName" },
              { label: "Last Name", name: "lastName" },
              { label: "Date of Birth", name: "dateOfBirth", type: "date" },
              { label: "Email", name: "email", type: "email" },
              { label: "Phone", name: "phone", type: "tel" },
              { label: "Created/ Updated By", name: "createdBy" },
            ].map(({ label, name, type = "text" }) => (
              (
                ["New Enrolment", "Offer Letter Generated & Sent"].includes(
                  formData?.studentStatus
                ) &&
                name === "studentId"
              ) ?
                <div key={name} className="form-group">
                <label>{label}</label>
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div> : <div key={name} className="form-group">
                <label>{label}</label>
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>
            ))}

            <div className="form-group">
              <label>Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                className="form-input"
                required
              >
                <option value="">Select</option>
                {options.gender.map((g) => (
                  <option key={g} value={g}>
                    {g}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Agent Name</label>
              <select
                  name="agentName"
                  value={formData.agentName}
                  onChange={handleInputChange}
                  className="form-input"
              >
                  <option value="">-- Select Agent --</option>
                  {agentList.map((agent) => (
                  <option key={agent.id} value={agent.agentName}>
                      {agent.agentName}
                  </option>
                  ))}
              </select>
            </div>

            <div className="form-group">
              <label>USI Number</label>
              <input
                type="text"
                name="usiNumber"
                value={formData.usiNumber}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label>Student Status</label>
              <select
                name="studentStatus"
                value={formData.studentStatus || ""}
                onChange={handleInputChange}
                className="form-input"
              >
                <option value="">Select Status</option>
                {[
                  "New Enrolment",
                  "Offer Letter Generated & Sent",
                  "Graduated",
                  "Cancelled",
                  "Ongoing",
                  "Finished",
                  "Failed",
                  "Forwarded to Debt Collector",
                  "Upcoming - Awaiting Visa (COE) or Course not Started (VOE/Onshore)",
                  "Waiting for Visa",
                  "Withdrawn/Discontinued",
                  "Unknown - Completion date passed",
                  "Others - Change campus etc",
                  "Visa Refused",
                ].map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Leading To</label>
              <input
                type="text"
                name="leadingTo"
                value={formData.leadingTo}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>
          </div>
        </div>
        {/* Emergency Details */}
        <div className="form-section">
          <h2>Emergency Details</h2>
          <br />

          <div className="form-grid">
            <div className="form-group">
              <label>Emergency Contact Name</label>
              <input
                type="text"
                name="emergencyContactName"
                value={formData.emergencyContactName}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Full name of emergency contact"
              />
            </div>

            <div className="form-group">
              <label>Emergency Contact Relation</label>
              <input
                type="text"
                name="emergencyContactRelation"
                value={formData.emergencyContactRelation}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g., Parent, Friend, Sibling"
              />
            </div>

            <div className="form-group">
              <label>Emergency Contact Telephone</label>
              <input
                type="tel"
                name="emergencyContactNumber"
                value={formData.emergencyContactNumber}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Emergency contact number"
              />
            </div>
          </div>
        </div>

        {/* Address & Campus */}
        <div className="form-section">
          <h2>Address & Campus</h2>
          <br />
          <div className="form-grid">
            <div className="form-group">
              <label>Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter address"
              />
            </div>
            <div className="form-group">
              <label>Suburb</label>
              <input
                type="text"
                name="suburb"
                value={formData.suburb}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter suburb"
              />
            </div>
            <div className="form-group">
              <label>State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g. VIC"
              />
            </div>
            <div className="form-group">
              <label>Postcode</label>
              <input
                type="text"
                name="postcode"
                value={formData.postcode}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter postcode"
              />
            </div>
            <div className="form-group">
              <label>Onshore Address</label>
              <textarea
                name="onshoreAddress"
                value={formData.onshoreAddress}
                onChange={handleInputChange}
                className="form-textarea"
              />
            </div>
            <div className="form-group">
              <label>Offshore Address</label>
              <textarea
                name="offshoreAddress"
                value={formData.offshoreAddress}
                onChange={handleInputChange}
                className="form-textarea"
              />
            </div>
            <div className="form-group">
              <label>Campus Name</label>
              <select
                name="campusName"
                value={formData.campusName}
                onChange={handleInputChange}
                className="form-input"
              >
                <option value="">Select</option>
                {options.campusName.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>COE Type</label>
              <select
                name="coeType"
                value={formData.coeType}
                onChange={handleInputChange}
                className="form-input"
              >
                <option value="">Select</option>
                {options.coeType.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Fee Plan Type</label>
              <select
                name="feePlanType"
                value={formData.feePlanType}
                onChange={handleInputChange}
                className="form-input"
              >
                <option value="">Select</option>
                {options.feePlanType.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Visa Application Type</label>
              <select
                name="visaApplicationType"
                value={formData.visaApplicationType}
                onChange={handleInputChange}
                className="form-input"
              >
                <option value="">Select</option>
                {options.visaApplicationType.map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Enrolment Type</label>
              <select
                name="enrolmentType"
                value={formData.enrolmentType}
                onChange={handleInputChange}
                className="form-input"
              >
                {options.enrolmentType.map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label style={{display:"flex", alignItems:"center", gap:"8px"}}>
                Axcelerate Contact ID
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{padding:"2px 8px", fontSize:"0.8rem"}}
                  onClick={handleEditContactID}
                >
                  {isEditingContactID ? "Lock" : "Edit"}
                </button>
                <a 
                  href={`https://ciet.app.axcelerate.com/management/management2/contact_View.cfm?contactID=${formData.contactID}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Link
                </a>
              </label>

              <input
                type="text"
                name="contactID"
                value={formData.contactID}
                onChange={handleInputChange}
                className="form-input"
                disabled={!isEditingContactID}
              />
            </div>
          </div>
        </div>

        {/* Passport & Visa Details */}
        <div className="form-section">
          <h2>Passport & Visa Details</h2>
          <br />
          <div className="form-grid">
            <div className="form-group">
              <label>Citizenship</label>
              <input
                type="text"
                name="citizenship"
                value={formData.citizenship}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter citizenship"
              />
            </div>

            <div className="form-group">
              <label>Passport Number</label>
              <input
                type="text"
                name="passportNumber"
                value={formData.passportNumber}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter passport number"
              />
            </div>

            <div className="form-group">
              <label>Passport Expiry</label>
              <input
                type="date"
                name="passportExpiry"
                value={formData.passportExpiry}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label>Visa Type</label>
              <input
                type="text"
                name="visaType"
                value={formData.visaType}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g. Student Visa 500"
              />
            </div>

            <div className="form-group">
              <label>Visa Expiry Date</label>
              <input
                type="date"
                name="visaExpiryDate"
                value={formData.visaExpiryDate}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>
          </div>
        </div>

        {/* Courses Section */}
        <div className="form-section">
          <h2>Course Entries</h2>
          {courses.map((course, idx) => (
            <div key={course.id || idx} className="course-entry">
              <h4>Course #{idx + 1}</h4>
              <div className="form-grid">
                {[
                  { name: "courseName", placeholder: "Course Name", type: "select"}, // change to select
                  { name: "coeNumber", placeholder: "COE Number"},
                  { name: "courseStartDate", type: "date"},
                  { name: "courseEndDate", type: "date"},
                  { name: "coeIssuedDate", type: "date"},
                  { name: "prismsDueDate", type: "date"},
                  { name: "courseDuration", type: "number"},
                  { name: "courseHolidayWeeks", type: "number"},
                  { name: "courseTuitionWeeks", type: "number"},
                  { name: "classPerWeek", placeholder: "Class Per Week", type:"select"},
                  { name: "remarks", placeholder: "Remarks"},
                  { name: "revisedCOE", placeholder: "Revised COE"},
                ].map(({ name, type = "text", placeholder }) => (
                  <div key={name} className="form-group">
                    <label>
                      {placeholder || name.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                    </label>

                    {/* Use select for courseName */}
                    {name === "courseName" ? (
                      <select
                        name={name}
                        value={course[name]}
                        onChange={(e) => handleCourseChange(idx, e)}
                        className="form-input"
                      >
                        <option value="">Select Course</option>
                        {availableCourses.map((c) => (
                          <option key={c.courseCode} value={c.courseName}>
                            {c.courseCode} - {c.courseName}
                          </option>
                        ))}
                      </select>
                    ) : name === "classPerWeek" ? (
                      <select
                        name={name}
                        value={course[name]}
                        onChange={(e) => handleCourseChange(idx, e)}
                        className="form-input"
                      >
                        {options.classPerWeek.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    ) : ["remarks", "comments"].includes(name) ? (
                      <textarea
                        name={name}
                        value={course[name]}
                        onChange={(e) => handleCourseChange(idx, e)}
                        className="form-textarea"
                      />
                    ) : (
                      <input
                        type={type}
                        name={name}
                        value={course[name]}
                        onChange={(e) => handleCourseChange(idx, e)}
                        className="form-input"
                      />
                    )}
                  </div>
                ))}

                {["coeStatus", "decision", "prismStatus"].map((key) => (
                  <div key={key} className="form-group">
                    <label>
                      {key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                    </label>
                    <select
                      name={key}
                      value={course[key]}
                      onChange={(e) => handleCourseChange(idx, e)}
                      className="form-input"
                    >
                      <option value="">Select {key.replace(/([A-Z])/g, " $1")}</option>
                      {options[key].map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>

              <button
                type="button"
                className="btn btn-danger"
                onClick={() => removeCourse(idx)}
                disabled={courses.length === 1}
                style={{ marginTop: "0.5rem" }}
              >
                Remove Course
              </button>
              <hr />
            </div>
          ))}

          <button type="button" className="btn btn-secondary" onClick={addCourse}>
            + Add Course
          </button>
        </div>


      </form>
    </div>
  );
}

export default StudentRecordForm;